define('modules/integrations/services/shopify/view',['require','exports','module','views/BaseView','views/AlertView','jquery','ldsh!./template'],function (require, exports, module)
{
  'use strict';

  var BaseView = require('views/BaseView'),
          AlertView = require('views/AlertView'),
          $ = require('jquery');

  var View = BaseView.extend({
    events: {
      'click #buttonIntegrationsShopifyForce' : 'forceSync',
      'click #buttonIntegrationsShopifyDisConnect' : 'disConnect'
    },
    template: require('ldsh!./template'),
    alertView: null,
    integrations: null,

    blockGroupSelector: function () {
      var $groupOption = $('#integrations')
          .find('#company-drop-menu')
          .find('.company-selector')
          .first();

      $groupOption.addClass('disabled').on('click', function (e) {
        e.preventDefault();
        return false;
      });
    },

    initFormValidation: function () {
      var self = this;
      $('#form-integrations-shopify').bootstrapValidator({
        onSuccess: function (){
          self.save();
        },

        onError: function (){
          self.alertView = new AlertView({
            el: '#messages-container',
            type: 'danger',
            msg: 'ACCOUNTS.USERS.MSG_VALIDATION_ERR'
          });

          self.alertView.render();
        }
      });
    },

    afterRender: function (){
      BaseView.prototype.afterRender.call(this);

      this.initAlerts();
      this.blockGroupSelector();
      this.initFormValidation();
      this.enableButtons();

      $('.i18n').i18n();
    },

    showSuccessModal: function (label){
      this.alertView = new AlertView({
        el: '#messages-container',
        type: 'success',
        msg: label
      });

      this.alertView.render();
    },

    getFormData: function () {
      var form = this.$el.find('#form-integrations-shopify'),
          data = {};

      form.serializeArray().map(function (item) {
        data[item.name] = item.value;
      });

      return data;
    },

    save: function (){
      var self = this;
      var formData = this.getFormData();

      var data = {
        integrations: {
          shopify: {
            storeId: formData.shopify_store_id,
            accessToken: formData.shopify_access_token,
            listId: formData.shopify_list_id,
            apiSecret: formData.shopify_api_secret,
          }
        }
      };

      this.model.save(data, {
        type: 'PUT',

        success: function (){
          self.showSuccessModal('INTEGRATIONS.SHOPIFY.MSG_OK');
        },

        error: function (model, response){
          console.log(response);
        }
      });
    },

    initAlerts: function () {
      if (this.alertView) {
        $("#messages-container").append(this.alertView.render().el);
      }
    },

    getCurrentGroupId: function () {
      return this.group.get('selectedCompany') || this.group.get('id');
    },

    loadIntegrations: function () {
      var self = this,
          fetchParams = {
            success: function (response) {
              self.integrations = response;
            }
          };

      this.model.setGroupId(this.getCurrentGroupId()).fetch(fetchParams);
    },

    initialize: function (){
      var self = this;
      this.alertView = null;

      if (!this.model.isRequest) {
        this.loadIntegrations();
      }

      this.listenTo(this.model, 'reset sync request error', function (){
        self.render();
      });

    },

    serialize: function (){
      return {
        shopify: this.integrations ? this.parseData(this.integrations.get('integrations')) : {}
      };
    },

    parseData: function (integrations) {
      if (!integrations.shopify)
        return {};
      if (!integrations.shopify.synchronizeAt)
        return integrations.shopify;
      var now = new Date();
      var offset = now.getTimezoneOffset();

      var dateString = integrations.shopify.synchronizeAt;
      var date = dateString.match(/\d+/g);
      var synchronizeAt = new Date(date['2'], date['1'] - 1, date['0'], date['3'], date['4'], date['5']);
      synchronizeAt.setTime(synchronizeAt.getTime() +
        Math.abs((parseInt(date['6'], 10) + Math.abs((offset / 60)))) * 60 * 60 * 1000);
      integrations.shopify.synchronizeAt = synchronizeAt;
      return integrations.shopify;
    },

    enableButtons:function (){
      if(this.integrations){
        this.enableButtonDisConnect(this.integrations.get('integrations'));
        this.enableButtonForceSync(this.integrations.get('integrations'));
      }
    },
    enableButtonDisConnect:function (integrations){
      if(integrations && integrations.shopify && integrations.shopify.isConnect){
        $('#buttonIntegrationsShopifyDisConnect').removeClass('disabled');
      }else{
        $('#buttonIntegrationsShopifyDisConnect').addClass('disabled');
      }
    },

    enableButtonForceSync:function (integrations){
      if(integrations && integrations.shopify && integrations.shopify.isConnect && integrations.shopify.synchronizeAt){
        var now = new Date();
        var diffTime = Math.abs(now - integrations.shopify.synchronizeAt);
        var diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
        if(diffHours > 1){
          $('#buttonIntegrationsShopifyForce').removeClass('disabled');
        }
      }
    },

    forceSync: function(event) {
      console.log('forceSync', event);
        var self = this;
        var data = {integrations: {shopify: {}}};

        this.model.save(data, {
          type: 'PATCH',
          success: function (){
            self.showSuccessModal('INTEGRATIONS.SHOPIFY.MSG_OK_SYNC');
          },

          error: function (model, response){
            console.log(response);
          }
        });
    },

    disConnect: function(event) {
      console.log('disConnect',event);
      var self = this;
      var data = {integrations: {shopify: {}}};

      this.model.save(data, {
        type: 'DELETE',
        url:this.model.url()+'?integration=shopify',
        success: function (){
          self.showSuccessModal('INTEGRATIONS.SHOPIFY.MSG_OK_DISCONNECT');
          self.enableButtons();
        },

        error: function (model, response){
          console.log(response);
        }
      });
    },
  });

  module.exports = View;
});

